import './lib/sentry';
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { ToastProvider } from './contexts/ToastContext';
import { validateApiConfig } from './config/api'

// Validate API configuration on startup
validateApiConfig();

// Log environment details
console.group('🌍 Environment Configuration');
console.log('Mode:', import.meta.env.MODE);
console.log('Development:', import.meta.env.DEV);
console.log('Production:', import.meta.env.PROD);
console.log('Base URL:', import.meta.env.VITE_API_BASE_URL || 'Not set');
console.log('App URL:', import.meta.env.VITE_APP_URL || 'Not set');
console.groupEnd();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ToastProvider>
      <App />
    </ToastProvider>
  </React.StrictMode>,
)
